var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.finder.history.length > 0)?_c('button',{staticClass:"history-back",attrs:{"type":"button"},on:{"click":function () { return _vm.$store.dispatch('historyBack'); }}},[_c('Icon',{attrs:{"id":"chevron-left"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }